import { combineReducers } from 'redux';
import { edit } from './edit/edit.reducer';
import { list } from './list/list.reducer';
import { TrackHistory } from './track-history/track-history.reducer';

export const ScanRack = combineReducers({
    edit,
    list,
    TrackHistory,
});
